import styled from "styled-components/macro";
import { FormElementProps } from "./helpers";

export const CustomElement = styled.div`
    display: flex;
    align-items: center;
    margin: 10px 0;

    b {
        padding-left: ${(props: FormElementProps): string => `${props.customStyles?.paddingLeft}`};
        color: ${(props: FormElementProps): string => {
            if (props.disabled) {
                return "#CCCCCC";
            }

            return "#666666";
        }};
        font-size: 14px;
        font-weight: 400;

        &:hover {
            color: ${(props: FormElementProps): string => {
                if (props.disabled) {
                    return "#CCCCCC";
                }

                return "#1A1A1A";
            }};
        }
    }
`;
